import { ReactNode } from 'react';
import { Button } from 'react-bootstrap';
import { ModemData } from '../../api/Drone';
import useModemSubscription from './useModemSubscription';

function ModemSubscription({ drone }: { drone: ModemData }): ReactNode {
    const subscriptionInfo = useModemSubscription(drone);

    if (!subscriptionInfo) {
        return null;
    }

    return (
        <div className='settings-grid ts-16' style={{ alignItems: "baseline" }}>
            <div className='grid-1-2 t-big'>Подписка</div>
            <div className='grid-3-6 t-big'>
                <div>Действует до {new Date(subscriptionInfo.timeDeactivation).toLocaleDateString()}</div>
            </div>
            <div className='grid-3-6'>
                <Button onClick={() => { window.location.href = "/subscriptions" }} className='t-big'>Управление</Button>
            </div>
            <div className='grid-max'>
                <hr />
            </div>
        </div>
    );
}

export default ModemSubscription;
